import * as React from 'react'


export const CreditCardAuthorizationObj : CreditCardAuthorizationT = {

}

export interface CreditCardAuthorizationProps {

}

export interface CreditCardAuthorizationT {

}

const CreditCardAuthorization : React.FunctionComponent<CreditCardAuthorizationProps> = ({}) : JSX.Element => {
    return (
        <div>
            <p>
                I authorize StorageTransit to charge my credit card in the above amount based on
                the above contract and the governing contract. These charges are based on
                moving, storage and shipping charges which I have contracted and authorized with
                StorageTransit. I understand this amount is expected to be charged in accordance
                with terms on bill of lading. If credit card is used at time of delivery, I agree to
                authorize final charges days before delivery (2-4 days prior to delivery is preferred).
                Additionally, I understand a three and one half percent service fee (3.5%) is added to
                the total charge to cover credit card processing fees. If actual services or weight
                (based on size / weight determination) is greater than the amount authorized, I may
                owe an additional amount at or prior to delivery.
            </p>
        </div>
    )
}

export default CreditCardAuthorization